import React, { useEffect } from "react";
import { useStore } from "../../app/stores/store";
import ActivityTable from "./ActivityTable";
import { useTranslation } from "react-i18next";

export default function ActivityList() {
  const { t } = useTranslation();
  const loadActivities = useStore((s) => s.activityStore.loadActivities);

  useEffect(() => {
    loadActivities({});
  }, [loadActivities]);

  return <ActivityTable />;
}
